import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContextmenuOperationsService {
  private subject = new Subject<any>();

  constructor() { }


  getContextMenuObservable(){
    return this.subject.asObservable();
  }

  restoreTrashedObject(objects){
    var objList = [];
    objects.map(obj=>{
      objList.push({
        "parentObjectKey": obj["FullObject"] ? obj["FullObject"]["parentObjectKey"] : obj["parentObjectKey"],
        "objectKey":obj["FullObject"] ? obj["FullObject"]["objectKey"] : obj["objectKey"]
      })
    })
    this.subject.next({ "restore" : true, objectList:objList })
  }

  deleteTrashedObject(objects){
    var objList = [];
    objects.map(obj=>{
      objList.push( obj["FullObject"] ? obj["FullObject"]["objectKey"] : obj["objectKey"] )
    })
    this.subject.next({ "deleteforever" : true, objectList:objList })
  }

  leaveTeamFolder(teamfolder){
    this.subject.next({ "leaveTeamFolder" : true,teamfolder:teamfolder})
  }

  
}
